
// for socket.io
import socketIOClient from "socket.io-client";
import DeviceService from '@user-service//DeviceService';
import AuthProvider from '@user-provider/AuthProvider'
import Axios from 'axios';
import BridgeProvider from "./BridgeProvider";
import NetworkHelper from "../helper/NetworkHelper";
import GlobalAlertProvider from "./GlobalAlertProvider";

const zlib = require('zlib');

export default class SocketProvider {

    static socket
    static deviceInfo       //기기 정보

    static onConnect        //서버와 연결
    static onDisconnect     //서버와 종료

    static onMeasure        //측정중- 데이터 받음

    static onMeasureMonitor
    static onMeasureHit
    static onMeasureTime

    static onMeasureStart   //측정 시작
    static onMeasureStop    //측정 종료

    static onMeasureStartStatusBar
    static onMeasureStopStatusBar

    static onMeasureStopByAutoRun // 자동 시작시
    static onDeviceDisconnect   //브레인헬스 기기와 연결이 끊어짐
    static onDeviceStatus

    static onMessages

    static recvData = [] // 서버에서 받은데이터 
    static recvDataCount = 0  //서버에서 보낸 측정휫수 
    static recvDate;

    static sendData = []
    static sendDataCount = 0
    static eventWorker  // 서버에서 받은 데이터를 1초 마다 처리하기 위한 worker 
    static sendWorker

    static requestMeasure    // 측정 요청 파라미터
    static startCheckTimer          //시작 측정 여부 확  

    static fileKey
    static measureLogID

    static isBRHWService = false
    static isRunning = false
    static hasConnected = false          // 최초 연결 완료 여부
    static pause = false
    static measureHzType

    static useEndMeasureOfQueue = false
    static currentTime = 0

    // 누적 시간 관리
    static targetMeasureTime = 0        // 목표 측정 시간 (원래 요청 시간, DB 저장용)
    static deviceMeasureTime = 0        // 기기에 보내는 측정 시간 (목표 + 50% 여유)
    static accumulatedTime = 0          // 누적 측정 시간
    static lastMeasuredTime = 0         // 마지막 측정된 시간 (setStopStatus 영향 안받음)
    static isRetryMeasure = false       // 추가 측정 중 여부
    static onAutoRetryMeasure = null    // 추가 측정 시작 콜백

    static serialportLogs = []          // 시리얼포트 로그 저장
    static onSerialportLog = null       // 시리얼포트 로그 수신 콜백 (UI 업데이트용)

    static onDeviceMeasureDataConsole
    /**
     * 기기에서 보내는 이벤트 관련
     */
    static async initDeviceEvent(window){
        if(window && !window.app){
            window.app = {}
        }
        
        try {
          window.app.onDeviceMeasureData = null
          window.app.onDeviceMeasureDataUNC = null
          window.app.onDeviceMeasureStop = null
          window.app.onPacketError = null
          window.app.onMeasureError = null
          window.app.serialportLog = null
        } catch (e) {
          console.warn('[SocketProvider] initDeviceEvent clear failed:', e)
        }

        try {
            window.app.onDeviceMeasureData = (data) => {
                this.onDeviceMeasureData(data) 
            }
            window.app.onDeviceMeasureDataUNC = (data) => {
                const enc = NetworkHelper.getEncParam(JSON.parse(data))
                this.onDeviceMeasureData(enc)
            }
            
            window.app.onDeviceMeasureStop = () => { this.onDeviceMeasureStop() }
            window.app.onPacketError = () => {}

            // Windows 앱에서 측정 시작 실패 등의 에러 메시지를 받아서 글로벌 다이얼로그로 표시
            window.app.onMeasureError = (message) => {
                console.error('[SocketProvider] onMeasureError from device:', message)
                this.addSerialportLog('[오류] ' + message)
                GlobalAlertProvider.show(message, '측정 오류')
            }

            // Windows 앱에서 시리얼포트 연결 에러/로그를 실시간으로 받음
            window.app.serialportLog = (message) => {
                console.warn('[SocketProvider] serialportLog from device:', message)
                this.addSerialportLog(message)
            }

            /*
               안드로이드 이벤트 처리
             */
            window.app.onDeviceInfo = (deviceInfo) => {
                BridgeProvider.instance.resolve(deviceInfo)
            }
            window.app.onVersion = (version) => { BridgeProvider.instance.resolve(version) }
            window.app.onOsVersion = (version) => { BridgeProvider.instance.resolve(version) }
            window.app.onConnectedDevice =(isConnected) => { BridgeProvider.instance.resolve(isConnected)}

        } catch (e) {
            console.error('[SocketProvider] initDeviceEvent setup failed:', e)
        }

        this.isBRHWService = BridgeProvider.isBRHWService
    }

    /**
     * 기기에서 받은 데이터를 서버로 전송합니다.
     * @param data
     */
    static onDeviceMeasureData(data){
        this.sendDataCount++
        this.sendData.push({
            action: 'measure',
            data
        });
    }

    /**
     * stop from client
     * @returns {Promise<void>}
     */
    static async onDeviceMeasureStop(){
        this.sendData.push({
            action: 'stop',
        })
    }

    /**
     * sender queue worker
     */
    static startSendWorker() {
        this.clearSendWork()

        this.sendWorker = setInterval(() => {
            const queue = this.sendData.shift()

            if(!queue) return
            
            if(this.socket.connected){
                this.socket.emit('measure-queue', queue)
            } else {
                this.sendData.unshift(queue)
            }

        }, 300)
    }


    /**
     * clear sender worker
     */
    static clearSendWork(){
        if(this.sendWorker) {
            clearInterval(this.sendWorker)
        }

        this.sendData.length = 0
    }

    /**
     * parse received Data
     * @returns {boolean}
     */
    static parseReceivedData(){

        if(0 === this.recvData.length) { return false }
        if(this.pause) { return false }

        const queueData =  this.recvData.shift()
        if(!queueData) return false;

        const { data , action } = queueData

        try {
            switch (action){
                case 'measure':
                    const jsonString = zlib.inflateSync(Buffer.from(data, 'base64')).toString()
                    const parsedData = JSON.parse(jsonString)

                    if(parsedData.hzType === this.measureHzType){
                        if(this.onMeasure && parsedData){

                            if(this.currentTime === parsedData.time){
                                return false
                            }

                            this.onMeasure(parsedData)
                            const totalTime = this.accumulatedTime + parsedData.time
                            console.log(`[SocketProvider] onData - 현재: ${parsedData.time}초, 누적: ${totalTime}초 / 목표: ${this.targetMeasureTime}초`)

                            try { this.onMeasureHit(parsedData.isHit) } catch{}
                            try { this.onMeasureMonitor(parsedData) } catch{}

                            // 항상 마지막 측정 시간 저장
                            this.currentTime = parsedData.time
                            this.lastMeasuredTime = parsedData.time

                            if(this.onMeasureTime){
                                this.onMeasureTime(parsedData.time)
                            }

                            // 누적 시간이 목표에 도달하면 React에서 직접 종료
                            if(this.targetMeasureTime > 0 && totalTime >= this.targetMeasureTime){
                                console.log(`[SocketProvider] 목표 시간 도달 - 누적: ${totalTime}초 / 목표: ${this.targetMeasureTime}초, 종료 처리`)
                                this.onDeviceMeasureStop()
                            }
                        }
                    }
                    break
                case 'stop':
                    // 누적 시간 업데이트 (measure-queue로 stop이 온 경우)
                    this.accumulatedTime += this.lastMeasuredTime
                    console.log(`[SocketProvider] stop action - lastMeasuredTime: ${this.lastMeasuredTime}, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)

                    const remainingTime = this.targetMeasureTime - this.accumulatedTime
                    if(remainingTime > 1 && !this.isRetryMeasure) {
                        console.log(`[SocketProvider] 부족한 시간 ${remainingTime}초 - 추가 측정 시작 (fileKey 유지: ${this.fileKey})`)
                        this.isRetryMeasure = true
                        this.lastMeasuredTime = 0

                        // 기기에 직접 측정 시작 메시지 전송 (기존 fileKey 유지, 여유시간 적용)
                        try {
                            const deviceRemaining = Math.ceil(remainingTime * 1.5)
                            this.deviceMeasureTime = deviceRemaining
                            BridgeProvider.instance.deviceMeasureStart(deviceRemaining, this.requestMeasure.measureType).then()
                        } catch(e) {
                            console.error('[SocketProvider] 추가 측정 기기 시작 실패:', e)
                        }

                        // worker 재시작 (새로운 measure-start 없이 기존 세션 유지)
                        this.startSendWorker()
                        this.startEventWorker()

                        // 콜백 호출 (UI 업데이트용)
                        if(this.onAutoRetryMeasure) {
                            this.onAutoRetryMeasure(remainingTime)
                        }
                    } else {
                        this.measureStop().then()
                    }
                    break
                default:

            }
        }catch(e){ console.log(e);}
    }
    /**
     * start received data worker
     */
    static startEventWorker() {
        this.clearEventWorker()
        this.eventWorker = setInterval(this.parseReceivedData.bind(this),1000)
    }

    static clearEventWorker() {
        if(this.eventWorker) {
            clearInterval(this.eventWorker)
            this.eventWorker = null
        }
    }
    /**
     * get status from redis db
     * @returns {Promise<*>}
     */
    static async checkDeviceStatus(){
        const info = {
            memberID: '',
            token: '',
            mac: '',
        }

        if(AuthProvider.isCustomerView()){
            info.memberID = AuthProvider.getCustomerMemberID()
            info.token = AuthProvider.getToken()
            info.mac = AuthProvider.get('computerMac')
        } else {
            try {
                // const deviceInfo = await window.BRHW.getDeviceInfo()
                const deviceInfo = await BridgeProvider.instance.getDeviceInfo()
                const urlParams = new URLSearchParams(deviceInfo)

                info.token = urlParams.get('token')
                info.mac =  urlParams.get('mac')

            } catch (e) {
                console.error('[SocketProvider] checkDeviceStatus getDeviceInfo failed:', e)
            }
        }
        if('' === info.token && '' === info.memberID ){
            return null
        }

        const { data } = await DeviceService.connected(info);
        return data
    }
  
    static async applyGlobalConfig(){
      this.socket.emit('load-global-config')
    }
    
    /**
     * start measure to socket with device
     * @param measureTime
     * @param prescriptionID
     * @param hzType
     * @param measureType
     * @param measureTypeCode
     * @param measureCode
     * @param checkStartCallback
     * @param startCallback
     * @param stepCount
     * @param noiseCode
     * @returns {Promise<boolean>}
     */
    static async measureStart(
        measureTime,
        prescriptionID,
        hzType = 'default',
        measureType,
        measureTypeCode,
        measureCode = 'C',
        checkStartCallback = null,
        startCallback = null,
        stepCount = 1,
        noiseCode = 'A') {

        if(this.isRunning) { return false }
        if(!this.socket) { return false }

        this.setStopStatus()

        // 추가 측정이 아닐 때만 누적 시간 초기화
        if(!this.isRetryMeasure) {
            this.targetMeasureTime = parseInt(measureTime)
            this.deviceMeasureTime = Math.ceil(this.targetMeasureTime * 1.5)
            this.accumulatedTime = 0
            this.lastMeasuredTime = 0
            console.log(`[SocketProvider] 측정 시작 - 목표: ${this.targetMeasureTime}초, 기기전달: ${this.deviceMeasureTime}초, isRetry: false`)
        } else {
            this.lastMeasuredTime = 0  // 추가 측정도 새로 시작하므로 초기화
            console.log(`[SocketProvider] 추가 측정 시작 - 요청시간: ${measureTime}초, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)
        }

        try {

            this.requestMeasure = {
                profileID: AuthProvider.getProfileID(),
                measureBit: 256,
                measureTime: parseInt(measureTime),
                prescriptionID,
                measureType,
                measureTypeCode,
                measureCode,
                hzType,
                stepCount,
                deviceSerial: this.deviceInfo.deviceSerial,
                noiseCode: noiseCode
            }

            if(!this.isBRHWService){
                this.addSerialportLog('[오류] 기기와 연결되지 않았습니다. (기기 서비스 미연결)')
                GlobalAlertProvider.show('기기와 연결되지 않았습니다.', '연결 오류')
                if(startCallback) {
                    startCallback(false)
                }
                return false
            }

            this.startSendWorker()
            this.startEventWorker()
            this.setMeasureOption()

            this.socket.emit('measure-start',
                this.requestMeasure,
                ({success, message, fileKey, logID}) => {
                    this.fileKey = fileKey
                    this.measureLogID = logID

                    if (!success) {
                        if('EMPTY_HZ_SETTINGS' === message){
                            this.addSerialportLog('[오류] 측정 시작 실패: 주파수 설정값 없음')
                            GlobalAlertProvider.show('측정 시작에 실패했습니다. 설정값을 확인해주세요', '측정 오류')
                        } else if ('NOT_CONNECTED_DEVICE' === message){
                            this.addSerialportLog('[오류] 측정 시작 실패: 기기 미연결')
                            GlobalAlertProvider.show('기기와 연결되지 않았습니다. 연결을 확인해 주세요', '연결 오류')
                        }
                    } else {
                        this.isRunning = true

                        try {
                            // 기기에는 여유시간(+50%)이 적용된 시간을 전달
                            BridgeProvider.instance.deviceMeasureStart(this.deviceMeasureTime, measureType).then()

                            if(this.onMeasureStartStatusBar){
                                this.onMeasureStartStatusBar(this.requestMeasure)
                            }
                        } catch(e){
                            this.socket.emit('measure-start-failed', {
                                logID,
                                message: '[E_ST_0001] 측정시작실패'
                            })

                            this.clearSendWork()
                            // this.clearEventWorker()

                            this.addSerialportLog('[오류] 기기 측정 시작 실패: ' + (e.message || e))
                            GlobalAlertProvider.show('측정 시작에 실패했습니다. 다시 시도해 주세요', '측정 오류')
                            this.isRunning = false
                        }
                    }

                    if(startCallback){
                        startCallback(success)
                    }
                })
        }catch(e){
            this.addSerialportLog('[오류] 측정 시작 예외: ' + (e.message || e))
            GlobalAlertProvider.show('측정 시작에 실패했습니다', '측정 오류')
        }
    }
    /**
     * toggle device data
     * @returns {Promise<boolean>}
     */
    static async measurePauseToggle(){
        if(this.pause){
            try {
                this.pause = false
                await BridgeProvider.instance.deviceMeasureResume()
                // await window.BRHW.deviceMeasureResume()
            } catch (e) {
                console.error('[SocketProvider] deviceMeasureResume failed:', e)
            }
            return this.pause
        }

        try {
            if(this.isRunning){
                this.pause = true
                // await window.BRHW.deviceMeasurePause()
                await BridgeProvider.instance.deviceMeasurePause()
            }
        } catch (e) {
            console.error('[SocketProvider] deviceMeasurePause failed:', e)
        }

        return this.pause
    }

    /**
     * measure stop to device
     * @param withClearEvent
     * @param force
     * @returns {Promise<boolean>}
     */
    static async measureStop(withClearEvent = false, force= false){
        this.setStopStatus()

        if(withClearEvent){
            this.clearEvent()
        }

        if(!this.isBRHWService){
            return false
        }

        await this.deviceMeasureStop()

        this.clearSendWork()
        this.clearEventWorker()

        if(this.isRunning){
            try {
                this.socket.emit('measure-stop',{
                    measureBit: 256,
                    measureTime: 180,
                    deviceSerial: this.deviceInfo.deviceSerial,
                    fileKey: this.fileKey,
                    force
                })
            } catch(e){
                console.error('[SocketProvider] measure-stop emit failed:', e)
            }
            this.isRunning = false
        }
    }

    /**
     * send message to socket server
     * @param msgType
     * @param msgData
     * @returns {boolean}
     */
    static sendMessages(msgType, msgData){
        try {
            this.socket.emit('messages',{
                msgType,
                msgData,
                device: this.deviceInfo
            })
            return true
        } catch(e) {
            console.log(e);
        }

        return false
    }

    /**
     * clear on event
     */
    static clearEvent(){
        this.onMeasure = null
        this.onMeasureStart = null
        this.onMeasureStop = null
        this.onMeasureTime = null

        this.onMeasureRequest = null
    }

    static async deviceMeasureStop(){
        try {
            await BridgeProvider.instance.deviceMeasureStop()
        } catch(e) {
            console.error('[SocketProvider] deviceMeasureStop failed:', e)
        }
    }

    static setStopStatus() {
        this.currentTime = 0
        this.startCheckTimer = null

        this.recvData.length = 0
        this.recvData = []

        this.sendData.length = 0
        this.sendData = []

        this.recvDataCount = 0
        this.sendDataCount = 0

        this.useEndMeasureOfQueue = false
        this.pause = false

    }
    static setMeasureOption(){
        const useHzTypes = ['eeg', 'default']
        if(-1 < useHzTypes.indexOf(this.requestMeasure.hzType)){
            this.useEndMeasureOfQueue = true
        }
    }

    static async checkStartMeasure(callback) {
        if(this.startCheckTimer){
            clearTimeout(this.startCheckTimer)
        }

        this.startCheckTimer = setTimeout(async() => {
            try {
                this.recvDate.getTime()
                return false
            } catch (e){}

            this.socket.emit('measure-start', this.requestMeasure)
            await this.checkStartMeasure()
            if(callback){
                callback('restart')
            }
        },5000)
    }

    static log(messageType, message) {
        this.socket.emit('log',{
            deviceSerial: this.deviceInfo.deviceSerial,
            messageType,
            message,
        })
    }

    /**
     * 시리얼포트 로그를 내부에서 추가합니다.
     * @param {string} message
     */
    static addSerialportLog(message) {
        const logEntry = {
            time: new Date().toLocaleTimeString(),
            message: message
        }
        this.serialportLogs.push(logEntry)
        if (this.serialportLogs.length > 200) {
            this.serialportLogs.shift()
        }
        if (this.onSerialportLog) {
            this.onSerialportLog(logEntry)
        }
    }

    static isConnected(){
        try {
            return this.socket.connected
        } catch (e){ return false}
    }


    /**
     * socket connect with set events
     * @param callback
     * @param window
     * @param hzType
     * @returns {Promise<void>}
     */
    static async connect(callback, window, hzType) {
        if(AuthProvider.isAppMode()) return 
        
        try {
            await this.deviceMeasureStop()
        } catch (e) {
            console.warn('[SocketProvider] connect deviceMeasureStop failed:', e)
        }

        await this.initDeviceEvent(window)
        this.deviceInfo = await this.checkDeviceStatus()
    
        if(!this.deviceInfo){
            this.addSerialportLog('[오류] 기기 정보를 찾을 수 없습니다.')
            // 최초 연결 이후에만 다이얼로그 표시 (프로그램 시작 시에는 표시 안 함)
            if(this.hasConnected) {
                GlobalAlertProvider.show('기기 정보를 찾을 수 없습니다.\n기기 연결 상태를 확인해 주세요.', '연결 오류')
            }
            try {
                this.socket.disconnect()
            } catch(e){
                console.warn('[SocketProvider] disconnect on no deviceInfo failed:', e)
            }
            this.socket = null
            return
        }

        this.measureHzType = hzType
        if(this.socket && this.socket.connected){
            try {
                callback()
            } catch (e) {
                this.addSerialportLog('[오류] 소켓 연결 처리 실패: ' + (e.message || e))
                GlobalAlertProvider.show('소켓 연결 처리 중 오류가 발생했습니다.\n다시 시도해 주세요.', '연결 오류')
            }
            return
        }

        this.startEventWorker()

        let socketHost =  process.env.REACT_APP_SOCKET_HOST
        if(process.env.NODE_ENV === 'development'){
            const res = await Axios.get(`/api/host-ip`)
            socketHost = `${res.data}:4001`
        }
        
        this.socket = socketIOClient(socketHost, {
            path: process.env.REACT_APP_SOCKET_PATH,
            transports: ['websocket'],
            query: {
                APPLICATION_TYPE: this.isBRHWService ? 'PC' : 'WEB' ,
                // VERSION: this.isBRHWService ? await window.BRHW.getVersion() : '-',
                VERSION: this.isBRHWService ? await BridgeProvider.instance.getVersion() : '-',
                ROOM_ID: this.deviceInfo.roomID,
                DEVICE_ID:  this.deviceInfo.deviceID,
                PROFILE_ID : this.deviceInfo.profileID,
                DEVICE_SERIAL : this.deviceInfo.deviceSerial
            }
        });

        // 기존 리스너 제거 (중복 등록 방지)
        this.socket.off('connected')
        this.socket.off('measure-queue')
        this.socket.off('measure-start')
        this.socket.off('measure-stop')
        this.socket.off('messages')

        this.socket.on('connected',()=>{
            this.hasConnected = true
            this.socket.emit('web-login' , this.deviceInfo)
            if(this.onConnect) this.onConnect()
        })

        this.socket.on('measure-queue',(queue) => {
            // if(!this.isRunning){ return false }

            this.recvDataCount++
            this.recvDate = new Date()
            this.recvData.push(queue)
        })

        this.socket.on('measure-start',(data) => {
            if(this.onMeasureStart){
                this.onMeasureStart(data)
            }
        })

        this.socket.on('measure-stop',(data) => {
            this.clearSendWork()
            this.clearEventWorker()

            // 누적 시간 업데이트 (lastMeasuredTime 사용 - setStopStatus 영향 안받음)
            this.accumulatedTime += this.lastMeasuredTime
            console.log(`[SocketProvider] measure-stop - lastMeasuredTime: ${this.lastMeasuredTime}, accumulated: ${this.accumulatedTime}, target: ${this.targetMeasureTime}`)

            // 사용자 강제 중지가 아니고, 부족한 시간이 있으면 자동 추가 측정
            if(!data.force && !this.isRetryMeasure) {
                const remainingTime = this.targetMeasureTime - this.accumulatedTime
                if(remainingTime > 1) {
                    console.log(`[SocketProvider] 부족한 시간 ${remainingTime}초 - 추가 측정 시작`)
                    this.isRetryMeasure = true

                    if(this.onAutoRetryMeasure) {
                        setTimeout(() => {
                            this.onAutoRetryMeasure(remainingTime)
                        }, 1000)
                    }
                    return
                }
            }

            // 정상 종료 처리
            this.isRetryMeasure = false
            this.accumulatedTime = 0
            this.lastMeasuredTime = 0

            if(this.onMeasureStop) this.onMeasureStop(data)
            if(this.onMeasureStopByAutoRun) this.onMeasureStopByAutoRun(data)
            if(this.onMeasureStopStatusBar) this.onMeasureStopStatusBar(data)

            this.setStopStatus()
        })

        this.socket.on('messages', (data) => {
            if(this.onMessages){
                this.onMessages(data)
            }
        })

        if(callback){
            callback(this.deviceInfo.status)
        }
    }


    static getMeasureLogID(){
        return this.measureLogID
    }

    static getRequestMeasure(){
        return this.requestMeasure
    }

    static disconnect(){
        try {
            this.clearSendWork()
            this.clearEventWorker()
            this.socket.disconnect()
            this.socket = null
        } catch(e){
            console.error('[SocketProvider] disconnect failed:', e)
        }
    }
}
